import HIPAA from "@/assets/images/hipaa-compliant.png";
import benefitsHeroBanner from "@/assets/images/approvedHeroBanner2.jpg";
import benefitsHeroBannerV3 from "@/assets/images/benefitsHeroBannerV3.png";
import approvedHeroBanner2V2 from "@/assets/images/approvedHeroBanner2V2.png";
import licencedPharmaciesBanner from "@/assets/images/licencedPharmaciesBanner.jpg";
import licencedPharmaciesBannerV2 from "@/assets/images/licencedPharmaciesBannerV2.png";
import doctorHealthHistoryBanner from "@/assets/images/doctorHealthHistoryBanner.jpg";
import doctorHealthHistoryBannerV2 from "@/assets/images/doctorHealthHistoryBannerV2.png";
import doctorPrescribeBanner from "@/assets/images/doctorPrescribeBanner.png";
import doctorPrescribeBannerV2 from "@/assets/images/doctorPrescribeBannerV2.png";
import treatmentOption from "@/assets/images/treatmentOption.webp";
import treatmentOptionV2 from "@/assets/images/treatmentOptionV2.webp";
import treatmentOptionOral from "@/assets/images/treatmentOptionOral.webp";
import treatmentOptionItV2 from "@/assets/images/treatmentOptionItV2.webp";
import treatmentOptionOralV2 from "@/assets/images/treatmentOptionOralV2.webp";
import treatmentOptionPrescription from "@/assets/images/treatmentOptionPrescription.webp";
import treatmentOptionTablet from "@/assets/images/treatmentOptionTablet.png";
import treatmentOptionTirzepatideTablet from "@/assets/images/treatmentOptionTirzepatideTablet.webp";
import treatmentOptionTirzepatideTabletV2 from "@/assets/images/treatmentOptionTirzepatideTabletV2.webp";
import realUsersRealResultsBanner from "@/assets/images/beforeAfter/item4.jpg";
import ourGLPPlansImg from "@/assets/images/ourGLPPlans.jpg";
import { ReactComponent as RateIcon } from "@/assets/images/rate.svg";
import { ReactComponent as SignatureIcon } from "@/assets/images/signature.svg";
import { ReactComponent as LogoDefault } from "@/assets/images/logo.svg";
import { ReactComponent as LogoColorfulDefault } from "@/assets/images/skinny-logo-colorful.svg";

export const LogoIcon = () => (
  <LogoDefault className="w-24 sm:w-40 lg:w-52 -mt-12 sm:-mt-20 lg:-mt-20" />
);

export const LogoIconV2 = () => <LogoColorfulDefault />;

export {
  HIPAA,
  RateIcon,
  SignatureIcon,
  approvedHeroBanner2V2,
  benefitsHeroBanner,
  benefitsHeroBannerV3,
  realUsersRealResultsBanner,
  licencedPharmaciesBanner,
  licencedPharmaciesBannerV2,
  doctorHealthHistoryBanner,
  doctorHealthHistoryBannerV2,
  doctorPrescribeBanner,
  doctorPrescribeBannerV2,
  treatmentOption,
  treatmentOptionItV2,
  treatmentOptionOral,
  treatmentOptionPrescription,
  ourGLPPlansImg,
  treatmentOptionTablet,
  treatmentOptionTirzepatideTablet,
  treatmentOptionTirzepatideTabletV2,
  treatmentOptionV2,
  treatmentOptionOralV2,
};
